import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home/Home.vue';
import Gather from '@/views/gather/Gather.vue';
import Market from '@/views/home/Market.vue';
import Member from '@/views/home/Member.vue';
import MemberSecond from '@/views/home/MemberSecond.vue';
import Policy from '@/views/policy/index.vue';
import Login from '@/views/Login';
import SsoLogin from '@/views/SsoLogin';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: '/gather',
    name: 'Gather',
    component: Gather,
  },
  {
    path: '/market',
    name: 'Market',
    component: Market,
  },
  {
    path: '/member',
    name: 'Member',
    component: Member,
  },
  {
    path: '/membersecond',
    name: 'MemberSecond',
    component: MemberSecond,
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy,
  },
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/sso-login',
    name: 'SsoLogin',
    component: SsoLogin,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
